import { AxiosError } from 'axios'

export function getErrorMessage(
  error: unknown,
  fallback = 'An unexpected error occurred'
): string {
  if (error instanceof AxiosError)
    return error.response?.data?.detail ?? fallback
  if (error instanceof Error) return error.message
  return fallback
}
